import {Clearing} from 'biogas/clearing.js';
import "biogas/spinbataccount.js";

document.addEventListener("DOMContentLoaded", function() {
    var clearing = new Clearing();
    clearing.init();
});
